import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { clearError, getCoa } from "../redux/actions/productAction";
import "./coaPage.css";
import "./paged.css";

import Header from "../Components/Header";
import Helmet from "../Components/Helmet";
import { generatePDF, generatePDFWithOut } from "../Components/headerPdf";

const CoaPage = () => {
  const { error, loading, coa } = useSelector((state) => state.getCoa);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { coaId } = useParams();

  const [print, setPrint] = useState("");

  useEffect(() => {
    dispatch(getCoa(coaId));
  }, [dispatch]);

  // console.log(coa)

  useEffect(() => {
    if (error) {
      alert(error);
      dispatch(clearError());
    }
  }, [error]);

  // const [isPrint, setIsPrint] = useState(false)
  let isPrint = false;

  let company = coa?.name || "";
  company = company.split(" ")[0];

  const fileName = `${company}-${coa?.NAME.split(" ")[0]}`;

  const printHandle = () => {
    // setIsPrint(true)

    isPrint = true;
    if (print === "") {
      alert("Please select Format");
    } else if (isPrint) {
      const body = document.getElementById("root").innerHTML;

      // let coaContainer = document.getElementById(print === 'withHeader' ? 'coaContainerId' : 'withoutCoaContainerId').innerHTML
      let coaContainer = document.getElementById(
        "withoutCoaContainerId"
      ).innerHTML;
      // coaContainer =  coaContainer.classList.add("marginTop");
      // console.log(coaContainer)
      // coaContainer

      // const handleDownload = () => {

      const htmlContent = document.getElementById("pdfContent"); // Assuming you have an element with this ID
      if (print === "withHeader") {
        generatePDF(coaContainer, company, fileName);
      } else {
        generatePDFWithOut(coaContainer, fileName, company);
      }
      // };

      // document.getElementById('root').innerHTML = coaContainer
      // console.log(coaContainer)
      // window.print()
      // document.getElementById('root').innerHTML = body
      // window.location.reload();
      // isPrint = false
    }
  };

  // console.log(coa)

  const [topFV, setTopFV] = useState([]);

  useEffect(() => {
    // setTopFV(coa?.topFV);

    const result = coa?.topFV.flatMap(({ name1, value1, name2, value2 }) => {
      const result = [];
      if (name1 && value1) result.push({ name1, value1 });
      if (name2 && value2) result.push({ name1: name2, value1: value2 });
      return result;
    });

    coa?.MANUFACTURING_DATE &&
      result?.splice(2, 0, {
        name1: "MANUFACTURING DATE",
        value1: coa?.MANUFACTURING_DATE,
      });
    coa?.EXPIRY_DATE &&
      result?.splice(5, 0, {
        name1: "EXPIRY DATE",
        value1: coa?.EXPIRY_DATE,
      });
    coa?.COA_DATE &&
      result?.splice(8, 0, { name1: "COA DATE", value1: coa?.COA_DATE });

    const chunkArray = (arr, size) => {
      const result = [];
      for (let i = 0; i < arr?.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    };

    const groupedData = chunkArray(result, 3);

    setTopFV(groupedData);
  }, [coa]);

  // console.log(topFV);
  // Insert additional objects at specific indices

  // ---------------------------------------------------------------------------------------------

  return (
    <div>
      <Header />
      <Helmet title={`${coa?.type.toUpperCase()} | ${coa?.NAME}`} />

      <div id="coaContainerId" className="coaContainerPadding">
        <div className="coaContainer">
          <header id="Header">
            <div className="coaHeader">
              {/* <img src={require('../images/coa/bcpl.jpg')} alt="" /> */}
              {/* <img src={coa?.img} alt="" width={70} />
            <div className='headingBox'>
              <h2>{coa?.name}</h2>
              <p>{coa?.title}</p>
            </div> */}

              {company === "Banwari" && (
                <div className="banwariBox">
                  <img
                    src={require("../images/coa/BAPL.png")}
                    alt="LOGO"
                    width={90}
                  />
                  <div className="headingBox">
                    <h2>
                      {" "}
                      BANWARI <br /> CHEMICALS PVT. LTD.
                    </h2>
                    <p>(AGOW RECoGNTZED EXPoRT HoUSE)</p>
                  </div>
                </div>
              )}

              {company === "Samde" && (
                <div className="samdeBox">
                  <img
                    src={require("../images/coa/samde1.png")}
                    alt="LOGO"
                    width={100}
                  />
                  <div className="samheadingBox">
                    <h2>{coa?.name}</h2>
                    <div className="samdeCenter">
                      <div></div>
                      <p>100% EOU</p>
                      <div></div>
                    </div>

                    <div className="samdeFooter">
                      <p>Regd. Office :{coa?.address} </p>
                      <p>
                        Ph: {coa?.phone} | Email: {coa?.email} | Website :{" "}
                        {coa?.website}
                      </p>
                      <p>
                        {" "}
                        | CIN: {coa?.CIN} | GST: {coa?.GST}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {company === "Petorose" && (
                <div className="petroseBox">
                  <img
                    src={require("../images/coa/petrose.jpg")}
                    alt="LOGO"
                    width={100}
                  />
                  <div className="petHeadingBox">
                    <h2> {coa?.name}</h2>
                    <h5>INNOVATING AROMAS</h5>
                    <p>
                      (Formerly Known as BANWARI CHEMICALS PRIVATE LIMITED )
                    </p>
                  </div>
                </div>
              )}
            </div>
          </header>

          {/* id='coaContainerId' for print page */}
          <div id="withoutCoaContainerId">
            <div className={isPrint ? "coaProduct marginTop" : "coaProduct"}>
              <div className="p-r-1">
                {coa?.type.toUpperCase() === "SPEC"
                  ? "Specification Sheet"
                  : "CERTIFICATE OF ANALYSIS"}
              </div>
              <div className="p-r-2">{coa?.NAME}</div>

              <div className="pMBox">
                {coa &&
                  coa?.topFV?.map((item, i) => (
                    <div className="p-m-1">
                      {/* <div>
                        <b>{item.name1}</b> {item.value1}
                      </div>
                      <div>
                        <b>{item.name2}</b> {item.value2}
                      </div> */}

                      {/* ------------------------------------------------------------- dates ---------------------------------------------------------------- */}
                      {/* {coa?.type.toUpperCase() !== "SPEC" && (
                        <>
                          {i === 0 &&
                            (coa?.COA_DATE ||
                              coa?.EXPIRY_DATE ||
                              coa?.MANUFACTURING_DATE) && (
                              <div>
                                {" "}
                                <b> MANUFACTURING DATE :</b>{" "}
                                {coa?.MANUFACTURING_DATE}
                              </div>
                            )}
                          {i === 1 &&
                            (coa?.COA_DATE ||
                              coa?.EXPIRY_DATE ||
                              coa?.MANUFACTURING_DATE) && (
                              <div>
                                {" "}
                                <b>EXPIRY DATE :</b> {coa?.EXPIRY_DATE}
                              </div>
                            )}
                          {i === 2 &&
                            (coa?.COA_DATE ||
                              coa?.EXPIRY_DATE ||
                              coa?.MANUFACTURING_DATE) && (
                              <div>
                                {" "}
                                {coa?.COA_DATE ? (
                                  <>
                                    <b>COA DATE :</b> {coa?.COA_DATE}
                                  </>
                                ) : (
                                  "-"
                                )}
                              </div>
                            )}
                          {i >= 3 &&
                            (coa?.COA_DATE ||
                              coa?.EXPIRY_DATE ||
                              coa?.MANUFACTURING_DATE) && <div>-</div>}
                        </>
                      )} */}
                    </div>
                  ))}
              </div>

              <div className="pMBox">
                {coa &&
                  topFV?.map((chunk, i) => (
                    <div className="p-m-1">
                      {chunk?.map((item, i) => (
                        <div>
                          <b>{item.name1}</b> {item.value1}
                        </div>
                      ))}
                    </div>
                  ))}
              </div>

              <br />

              <div className={coa?.items1?.length > 0 && "pDbox"}>
                {/* custom 1 */}
                <div className="pD1">
                  <div className="center">Property</div>
                  <div className="center">Analysis</div>
                </div>
                {coa?.items1 &&
                  coa.items1.map((item) => (
                    <div className="pD1">
                      <div>{item.name}</div>
                      <div>{item.value}</div>
                    </div>
                  ))}
              </div>

              {/* ------------------------- Parameter Range Results -------------------------------------  */}

              {coa?.items2?.length > 0 && (
                <div className={coa?.items2?.length > 0 && "pDboxs"}>
                  <div className="pD1">
                    <div className="center">Parameter</div>
                    <div className="center">Range</div>
                    {coa?.type !== "spec" && (
                      <div className="center">Results</div>
                    )}
                  </div>

                  {coa?.items2 &&
                    coa.items2.map((item) => (
                      <div className="pD1">
                        <div>{item._name}</div>
                        <div>{item._value1}</div>
                        {coa?.type !== "spec" && <div>{item._value2}</div>}
                      </div>
                    ))}
                </div>
              )}

              {/* ---------------------------------------- custom GC ---------------------------------------  */}
              {coa?.itemsGc?.length > 0 && (
                <div className={coa?.itemsGc?.length > 0 && "pDboxd"}>
                  {coa?.itemsGc?.length > 0 && (
                    <div>
                      <div className="gc-heading center">{coa?.headingGc}</div>

                      <div className=" pDbox">
                        {coa?.itemsGc &&
                          coa.itemsGc.map((item) => (
                            <div className="pD1 ">
                              <div>{item.nameGc}</div>
                              <div>{item.valueGc}</div>

                              {coa?.type !== "spec" && (
                                <div>{item.valueGc2}</div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* <div className="pD1 ">
              <div> EXPIRY DATE <br /> MANUFACTURING  <br /> EXPIRY DATE   </div>
              <div>  {coa?.COA_DATE} <br /> {coa?.MANUFACTURING_DATE} <br /> {coa?.EXPIRY_DATE}  </div>
            </div> */}

              {/* <div className='dates'>

                  <div className="pD1-date">
                    <div>COA DATE </div>
                    <div>{coa?.COA_DATE}</div>
                  </div>
                  <div className="pD1-date">
                    <div>MANUFACTURING DATE  </div>
                    <div>{coa?.MANUFACTURING_DATE}</div>
                  </div>
                  <div className="pD1-date">
                    <div>EXPIRY DATE </div>
                    <div>{coa?.EXPIRY_DATE}</div>
                  </div>

                </div> */}

              {coa?.remark && (
                <p className="remark">
                  <b>Remark</b> : {coa?.remark}
                </p>
              )}
            </div>
          </div>

          <footer id="Footer">
            <p className="remark">
              This is a computer generated document and does not require any
              signature
            </p>
            {company === "Banwari" && (
              <div>
                <div className="BanwariFooter">
                  <p>Regd. Office :{coa?.address} </p>
                  <p>
                    Ph: {coa?.phone} | Email: {coa?.email} | Website:{" "}
                    {coa?.website}
                  </p>
                  <p>
                    {" "}
                    | CIN: {coa?.CIN} | GST: {coa?.GST}
                  </p>
                </div>
              </div>
            )}
            {company === "Petorose" && (
              <div id="bgPet">
                <div className="petroseFooter">
                  <p>Regd. Office :{coa?.address} </p>
                  <p>
                    Ph: {coa?.phone} | Email: {coa?.email} | Website:{" "}
                    {coa?.website}
                  </p>
                  <p>
                    {" "}
                    | CIN: {coa?.CIN} | GST: {coa?.GST}
                  </p>
                </div>
              </div>
            )}
          </footer>
        </div>
      </div>

      {/* ---------------------------------------------------Print offf------------------------------------------- */}
      <div className="createdBy">
        <div>CREATED BY </div> :<div>{coa?.createBy}</div>
      </div>

      <div className="printBox">
        <p>Select Format : </p>

        <div className="printRadio">
          <label>
            <input
              type="radio"
              onChange={(e) => setPrint(e.target.value)}
              name="print"
              value="withHeader"
            />
            With Header Footer
          </label>
          <label>
            <input
              type="radio"
              onChange={(e) => setPrint(e.target.value)}
              name="print"
              value="withoutHeader"
            />
            Without Header Footer
          </label>
        </div>

        {/* {print} */}
      </div>

      <div className="printBox">
        <button className="printBtn" onClick={printHandle}>
          Print
        </button>
        <Link className="editBtn" to={`/coa-edit/${coa?._id}`}>
          Edit
        </Link>
      </div>
    </div>
  );
};

export default CoaPage;
